export const required = (value) => {
    if (!`${value}`.length) {
        return 'Это поле обязательно для заполнения';
    }
    return null;
};
